var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHighPriority(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#FFEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4371 33.9812L17.4648 26.8562C16.8451 26.2229 16.8451 25.2333 17.4648 24.6L24.4371 17.475C25.0569 16.8417 26.0253 16.8417 26.645 17.475L33.6174 24.6C34.2371 25.2333 34.2371 26.2229 33.6174 26.8562L26.645 33.9812C26.0253 34.6146 25.0182 34.6146 24.4371 33.9812Z",
    fill: "#BF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.592 29.1917C24.592 29.073 24.6308 28.9542 24.6695 28.8355C24.7082 28.7167 24.7857 28.6375 24.8632 28.5584C24.9407 28.4792 25.0569 28.4 25.1731 28.3605C25.2893 28.3209 25.4055 28.2813 25.5604 28.2813C25.7154 28.2813 25.8316 28.3209 25.9478 28.3605C26.064 28.4 26.1802 28.4792 26.2577 28.5584C26.3351 28.6375 26.4126 28.7167 26.4513 28.8355C26.4901 28.9542 26.5288 29.073 26.5288 29.1917C26.5288 29.3105 26.4901 29.4292 26.4513 29.548C26.4126 29.6667 26.3351 29.7459 26.2577 29.825C26.1802 29.9042 26.064 29.9834 25.9478 30.023C25.8316 30.0625 25.7154 30.1021 25.5604 30.1021C25.4055 30.1021 25.2893 30.0625 25.1731 30.023C25.0569 29.9834 24.9794 29.9042 24.8632 29.825C24.7857 29.7459 24.7082 29.6667 24.6695 29.548C24.6308 29.4292 24.592 29.35 24.592 29.1917ZM26.2189 27.3709H24.8245L24.6308 21.3938H26.4126L26.2189 27.3709Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighPriority);
export default __webpack_public_path__ + "static/media/highPriority.cbd7a56685c43ef8ab9e21c9012bed8c.svg";
export { ForwardRef as ReactComponent };